import React, { useEffect, useState } from "react";
import { ROUTES } from "../../../../constant/routeConstant";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { GROLOG_URL } from "../../../../constant/apiConstant";
import { AutoComplete, Breadcrumb, Input, Tooltip } from "antd";
import style from "../DataGroup.module.css";
import { AscRed, CloseIconSearch, DeleteIcon, DescGrey, DetailIcon, EditIcon, SearchIcon } from "../../../../asset";
import Delete from "../../../../component/modal/ModalDelete";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import CustomTable from "../../../../component/table/CustomTable";
import CustomPaging from "../../../../component/pagination/pagination";
import { AddIcon } from "../../../../asset/icons";
import { useSelector } from "react-redux";

const ListDataGroup = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [sortBy, setSortBy] = useState("id");
  const [sortingName, setSortingName] = useState("asc");
  const [sortingDesc, setSortingDesc] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] = useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { "Authorization": token };
    const request = { url, method, headers, params };
    return axios(request);
  }

  const fetchData = async (data, sort, sortBy) => {
    setLoading(true)
    let res = await doGet(
      `/data-group?page=${page}&limit=${limit}&order=${sortBy} ${sort ? sort : sorting}${!isFilter
        ? ""
        : filter ? "&filter=data_group_id lk " + filter : data ? "&filter=data_group_id lk " + data : ""}&${param}`,
      token
    );
    let init = await doGet(
      `/data-group/initiate?page=${page}&limit=${limit}&order=${sortBy} ${sort ? sort : sorting}${!isFilter
        ? "" : filter ? "&filter=data_group_id lk " + filter : data ? "&filter=data_group_id lk " + data : ""}&${param}`,
        token
    );
    setListData(res?.data?.payload?.data);
    if (init?.data?.payload?.data) {
      setInitiate(init?.data?.payload?.data);
    } else { }
    setListData(res?.data?.payload?.data);
    setLoading(false)
  }

  useEffect(() => {
    fetchData(data, sorting, sortBy);
  }, [page, limit]);

  const handleEdit = (id) => {
    navigate(ROUTES.DATA_GROUP.EDIT, { state: { id , prevPage: location?.pathname } });
  }

  const handleDetail = (id) => {
    navigate(ROUTES.DATA_GROUP.DETAIL, { state: { id , prevPage: location?.pathname } });
  }

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  }

  const dataSource = listData
    ? listData.map((result) => ({
      id: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.id}
        </span>
      ),

      data_group_name: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.data_group_name}
        </span>
      ),
      description: (
        <span className="font-roboto text-lg text-[#222222]">
          {result?.description}
        </span>
      ),
      action: (
        <div className="flex gap-[26px]">
          <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
            <button onClick={() => handleEdit(result?.id)}>
              <img src={EditIcon} alt="edit" />
            </button>
          </Tooltip>
          <Tooltip title={t("Delete")} color="#CF0000">
            <button onClick={() => setModal(result)}>
              <img src={DeleteIcon} alt="del" />
            </button>
          </Tooltip>

          <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
            <button
              onClick={() => handleDetail(result?.id)}
            >
              <img src={DetailIcon} alt="det" />
            </button>
          </Tooltip>
        </div>
      ),
    })) : null;

  const doSort = async (sort, sortBy) => {
    setSorting(sort);
    setSortBy(sortBy)

    if (sort) {
      setSorting(sort);
      fetchData(data, sort, sortBy);
    }
  }

  const doSortName = async (sort) => {
    setSortingName(sort);

    if (sort) {
      setSortingName(sort);
      fetchData(data, sort);
    }
  }

  const doSortDesc = async (sort) => {
    setSortingDesc(sort);

    if (sort) {
      setSortingDesc(sort);
      fetchData(data, sort);
    }
  }

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("DATA_GROUP:TBL_ID")}
            </span>
          </div>
          <div style={{ marginTop: "3px", marginLeft: '10px' }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" && sortBy === "id" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortBy === "id"? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("asc", 'id');
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc" && sortBy === "id"? AscRed : DescGrey}
                  alt="desc"
                  className={sorting === "desc" && sortBy === "id"? "w-[10px] h-[10px] cursor-pointer rotate-180 " : "w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("desc", 'id');
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      render: (id) => <span>{id}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("DATA_GROUP:TBL_DATA_GROUP_NAME")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" && sortBy === "group_id"? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" && sortBy === "group_id" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("asc", 'group_id');
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "desc" && sortBy === "group_id"? AscRed : DescGrey}
                  alt="desc"
                  className={sorting === "desc" && sortBy === "group_id"? "w-[10px] h-[10px] cursor-pointer rotate-180 " : "w-[10px] h-[10px] cursor-pointer"}
                  onClick={() => {
                    doSort("desc", 'group_id');
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "data_group_name",
      key: "data_group_name",
      render: (data_group_name) => <span>{data_group_name}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("DATA_GROUP:TBL_DESCRIPTION")}
            </span>
          </div>
        </div>
      ),
      dataIndex: "description",
      key: "description",
      render: (description) => <span>{description}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMMON:ACTION")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    console.log(a, b);
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {

    }
  }

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
      let res = await doGet(`/data-group/search?page=1&limit=10&filter=data_group_id lk ${filters}`, token);
      setListRecommendation(res?.data?.payload?.data);
    }
  }

  const onSearchRecommendation = async (value) => {
    setIsfilter(true)
    setSearchRecommedation(value)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1, 10, value)
    } else {
    }
  }

  const onSelectRecommendation = (data) => {
    setFilter(data)
    fetchData(data, sorting, sortBy)
    setIsfilter(false)
  }

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);

    fetchData(data, sorting, sortBy);
  }

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.id}
        delete={showDelete}
        title={data?.data_group_name}
        url={"data-group"}
        action={() => setShowDelete(false)}
        route={ROUTES.DATA_GROUP.LIST}
        refresh={() => fetchData(data, sorting, sortBy)}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Admin</Breadcrumb.Item>
            <Breadcrumb.Item>User Management</Breadcrumb.Item>
            <Breadcrumb.Item>Data Group</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Data Group")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <AutoComplete
            options={options}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(value) => onSelectRecommendation(value)}
          >
            <Input
              placeholder={t("Search Data Group Name")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={filter ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={filter ? () => onClearRecommendation() : null}
                />
              }

              value={searchRecommendation}
            />
          </AutoComplete>
          <Link to={ROUTES.DATA_GROUP.ADD}>
            <PrimaryButton
              text={t("Add Data Group")}
              prefixIcon={<AddIcon />}
            />
          </Link>
        </div>

        {
          !loading ?
            <div className={style.tableContainer}>
              <CustomTable columns={ListColumn} data={dataSource} />
              <div className={style.containerPagination + " mt-[-45px]"}>
                <CustomPaging
                  idLimit="ddlrowsperpagemustselllist"
                  idPagination="btnpaginationmustselllist"
                  size="small"
                  current={page}
                  defaultCurrent={page}
                  pageSize={limit}
                  total={initiate && initiate?.count_data}
                  pageSizeOptions={initiate && initiate?.valid_limit}
                  onShowSizeChange={() => handlePagination()}
                  handlePaging={(a, b) => handlePagination(a, b)}
                  title={t("COMMON:ROW_PAGE")}
                />
              </div>
            </div>
            : "...loading"}
      </div>
    </>
  );
}

export default ListDataGroup;
